import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import Navigable, { NavigableEventListener } from '@philips-emr/tws-core/lib/component/types/navigable';
import { isEnumValid } from '@philips-emr/tws-utils';

import { RangeState } from '../calendar';
import { Range } from '../calendar/calendar-api';

import { DatePickerMode } from './constants';

class DatePickerAPI extends ComponentAPI implements Changeable<string>, Navigable<string> {

  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string>();

  /** @event */
  @AwesomeEvent
  onAfterNavigate = new NavigableEventListener<string>();

  /** @event */
  @AwesomeEvent
  onNavigate = new NavigableEventListener<string>();

  getInitialDate(): object {
    return this.state.initialDate;
  }

  setInitialDate(initialDate: object): void {
    this.setState({ initialDate });
  }

  getData(): object[] {
    return this.state.data;
  }

  setData(data: object[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  isInterval(): boolean {
    return this.state.interval;
  }

  setInterval(interval: boolean): void {
    this.setState({ interval });
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    this.setState({ value });
  }

  getMode(): DatePickerMode {
    return this.state.mode;
  }

  setMode(mode: DatePickerMode): void {
    if (isEnumValid(DatePickerMode, mode)) {
      this.setState({ mode });
    }
  }

  getRanges(): Range[] {
    return [...(this.state.ranges || [])];
  }

  setRanges(ranges: Range[]): void {
    this.setState({ ranges });
  }

  addRange(startDate: string, endDate: string): void {
    const ranges = this.getRanges();
    ranges.push({ startDate, endDate });
    this.setRanges(ranges);
  }

  addRanges(ranges: Range[]): void {
    const oldRanges = this.getRanges();
    this.setRanges(oldRanges.concat(ranges));
  }

  clearRanges(): void {
    this.setRanges([]);
  }

  setRangeState(rangeState: RangeState): void {
    this.setState({ rangeState });
  }

  getRangeState(): RangeState {
    return this.state.rangeState;
  }

  setLoading(loading: boolean): void {
    this.setState({ loading });
  }

  isLoading(): boolean {
    return this.state.loading;
  }
}

export default DatePickerAPI;
